export const tabsInfo = [
  {value: "Thông tin cá nhân", selected: true},
  {value: "L.Sử giao dịch", selected: false},
  {value: "Lịch hẹn sắp tới", selected: false},
  {value: "Thẻ dịch vụ", selected: false},
  {value: "Thăm khám", selected :false},
]